import { useContext, useEffect, useState } from 'react';
import { NextPage } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Job from 'models/Job';

import { LIST_MARKUP } from 'consts/redux';
import { selectCmsPageSection } from 'utils/locale';

import { list as listJobs } from 'requests/jobs';

import LocaleContext from 'components/context/Locale';
import Head from 'components/layout/Head';
import LayoutDefault from 'components/modules/public/layouts/Default';
import Page404 from 'components/modules/public/pages/404';

import SectionBackground from './sections/Background';
import SectionCompany from './sections/Company';
import { Props } from './index';
import StyledComponent from './styles';

const PublicPageCompanySite: NextPage<Props> = ({ company, cmsPage, notFound, state }) => {
    const [jobsList, setJobsList]: [ListCollection<Job>, Function] = useState(null);
    const companyId = company?.company?.id;
    const { authToken, profile } = state;
    const userCompanyId = profile?.company?.id;
    let isAuthorizedUser;
    if(authToken) {
        isAuthorizedUser = userCompanyId === companyId;
    } else {
        isAuthorizedUser = false;
    }
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.companySite;

    if (!company || notFound) {
        return (<Page404 />);
    }

    const loadJobsData = () => {
        setJobsList({
            ...LIST_MARKUP,
            isLoading: true,
            isLoaded: false,
        });


        listJobs({
            page: 1,
            perPage: 999,
            companyId,
        })
            .then(listCollection => {
                setJobsList({
                    ...LIST_MARKUP,
                    ...listCollection,
                });
            })
            .catch(error => {
                console.error(error);
                setJobsList({
                    ...LIST_MARKUP,
                    isLoading: false,
                    isLoaded: false,
                    error: true,
                });
            });
    };

    useEffect(() => {
        if (companyId) loadJobsData();
    }, []);

    return (
        <StyledComponent className="public-page-company-site">
            <Head
                {...data.meta}
                title={cmsPage?.metaTitle?.replace('{company}', company?.company?.name) || data?.meta?.title?.replace('{company}', company?.company?.name)}
                description={cmsPage?.metaDescription || company?.description}
                robots={cmsPage?.metaRobots}
                image={cmsPage?.image?.imageUrl}
            />
            <LayoutDefault>
                <SectionBackground background={company?.bgImage} />
                <SectionCompany
                    translations={{
                        ...data?.content?.companyCopy,
                        ...selectCmsPageSection(cmsPage, 'companycopy'),
                    }}
                    company={company}
                    jobsList={jobsList?.elements}
                    isEditable={isAuthorizedUser}
                />
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicPageCompanySite;
